import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/ErrorEntity";
import di from "../../../../DependencyInjection";
import HostApi, { HostApiName } from "../../../settings/HostApi";

const DeleteShiftApiImpl = async (id: string): Promise<Either<ErrorEntity, void>> => {
    try {
        const relativeUrl: string = `/turns/valet/admin/${id}`;
        await di.get<HostApi>(HostApiName).remove(relativeUrl);
        return right(undefined);
    } catch (e) {
        return left({ code: "Error" });
    }
}

export default DeleteShiftApiImpl;